module.exports = __webpack_public_path__ + "img/crew_adv_04.608c47ae.png";